export default __webpack_public_path__ + "static/media/0xc7ad46e0b8a400bb3c915120d284aafba8fc4735.75fa6063.svg";